import { useNavigate } from '@tanstack/react-router';
import { CheckCircle } from 'lucide-react';

import { useTranslation } from '../../hooks/useTranslation';
import Button from './Button';

interface ConfirmationMessageProps {
  title: string;
  message: string;
  howItwork?: string;
  buttonLabel?: string;
  redirect?: string;
}

const ConfirmationMessage = ({
  title,
  message,
  howItwork,
  buttonLabel,
  redirect,
}: ConfirmationMessageProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const returnTo = t('returnTo');

  const to = redirect ? redirect : '/';
  const returnText = buttonLabel
    ? `${returnTo} ${buttonLabel}`
    : t('returnHome');

  return (
    <div className="max-w-md mx-auto text-center py-20">
      <div className="mb-8 flex justify-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
          <CheckCircle className="w-12 h-12 text-green-500" />
        </div>
      </div>

      <h2 className="text-3xl font-bold text-gray-900 mb-4">{title}</h2>

      <p className="text-lg text-gray-600 mb-8">{message}</p>

      {howItwork && (
        <div className="bg-blue-50 p-6 rounded-lg mb-8">
          <h3 className="text-lg font-semibold text-blue-900 mb-2">
            What's Next?
          </h3>
          <p className="text-blue-700">{howItwork}</p>
        </div>
      )}

      <Button
        variant="primary"
        size="lg"
        className="w-full cursor-pointer"
        onClick={() => navigate({ to })}
        loading={false}
      >
        {returnText}
      </Button>
    </div>
  );
};

export default ConfirmationMessage;
